<template>
    <div class="billcycle-container">
        <accountPeriod :columns="columns"
                       :searchColumns="searchColumns"
                       @handleTask="toggleTask"
                       @handleExport="toggleExport" />
    </div>
</template>
<script>
import expandcycle from '@/views/console/bills/components/expandcycle.vue'
import accountPeriod from '@/views/console/bills/components/accountperiod.vue'

export default {
    name: 'billCycle',
    components: {
        accountPeriod
    },
    data () {
        return {
            billTypeMap: Object.freeze({
                SubscriptionOrder: this.$t('预付费'),
                PayAsYouGoBill: this.$t('后付费')
            }),
            priceTypeMap: Object.freeze({
                resource: this.$t('资源计费'),
                service: this.$t('服务计费')
                // extraConfig: this.$t('配置计费')
            }),
            searchColumns: Object.freeze([
                {
                    key: 'subscriptionType',
                    title: this.$t('计费类型'),
                    searchDefaultValue: '',
                    searchType: 'select',
                    searchData: [
                        { value: 'SubscriptionOrder', name: this.$t('预付费') },
                        { value: 'PayAsYouGoBill', name: this.$t('后付费') }
                    ]
                },
                {
                    key: 'priceType',
                    title: this.$t('账单类型'),
                    searchDefaultValue: '',
                    searchType: 'select',
                    searchData: [
                        { value: 'resource', name: this.$t('资源计费') },
                        { value: 'service', name: this.$t('服务计费') }
                        // { value: 'extraConfig', name: '配置计费' }
                    ]
                }
            ]),
            columns: [
                {
                    type: 'expand',
                    width: 40,
                    render: (h, params) => {
                        return h(expandcycle, {
                            props: {
                                ids: params.row.ids,
                                statusMap: this.$attrs.statusMap
                            }
                        })
                    }
                },
                {
                    title: this.$t('账单周期'),
                    key: 'billingCycle',
                    sortKey: 'billingCycle',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    width: 90,
                    resizable: true,
                    render: (h, params) => h('span', { attrs: { title: params.row.billingCycle } }, params.row.billingCycle)
                },
                {
                    title: this.$t('计费类型'),
                    key: 'billType',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 90,
                    // align: 'center',
                    render: (h, params) => {
                        const { billType } = params.row
                        const billTypeStr = this.billTypeMap[billType] || '--'
                        return h('span', {}, billTypeStr)
                    }
                },
                {
                    title: this.$t('账单类型'),
                    key: 'priceType',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 100,
                    renderHeader: (h, params) => {
                        return h('div', { style: { display: 'inline-block' } },
                            [
                                h('span', this.$t('账单类型')),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [h('i', {
                                    class: {
                                        'icon-prompt-1-o': true,
                                        'tips-style': true
                                    },
                                    style: {
                                        'font-size': '12px',
                                        'padding-right': '5px',
                                        'margin-left': '5px'
                                    }
                                }),
                                h('div', { slot: 'content' }, [
                                    h('p', this.$t('资源计费：实际资源产生的费用')),
                                    h('p', this.$t('服务计费：针对产品服务项的计费'))
                                    // h('p', this.$t('配置计费：额外配置费用'))
                                ]
                                )]
                                )
                            ])
                    },
                    render: (h, params) => {
                        const { priceType } = params.row
                        const priceTypeStr = this.priceTypeMap[priceType] || '--'
                        return h('span', {}, priceTypeStr)
                    }
                },
                {
                    title: this.$t('原始金额'),
                    key: 'pretaxGrossAmount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 140,
                    align: 'right',
                    render: (h, params) => {
                        const { pretaxGrossAmount } = params.row
                        return h('span', { class: pretaxGrossAmount >= 0 ? 'balance-color' : 'balance-color-green', attrs: { title: pretaxGrossAmount } }, this.$money(pretaxGrossAmount, 5) || '--')
                    }
                },
                {
                    title: this.$t('优惠金额'),
                    key: 'discountTotalAmount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 160,
                    align: 'right',
                    renderHeader: (h, params) => {
                        return h('div', { style: { display: 'inline-block' } },
                            [
                                h('span', { attrs: { title: this.$i18n.t('优惠金额') } }, this.$t('优惠金额')),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'right', theme: 'light' }
                                }, [h('i', {
                                    class: {
                                        'icon-prompt-1-o': true,
                                        'tips-style': true
                                    },
                                    style: {
                                        'font-size': '12px',
                                        'padding-right': '5px',
                                        'margin-left': '5px'
                                    }
                                }),
                                h('div', {
                                    slot: 'content',
                                    style: {
                                        // color: '#ff6a01'
                                    }
                                }, [
                                    h('p', this.$t('包含折扣优惠、折扣包优惠、优惠券抵扣金额、充值现金券支付金额、抵扣现金券支付金额。'))
                                ]
                                )]
                                )
                            ])
                    },
                    render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.discountTotalAmount } }, this.$money(params.row.discountTotalAmount, 5))
                },
                {
                    title: this.$t('现金支付金额'),
                    key: 'cashAmount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 160,
                    align: 'right',
                    render: (h, params) => h('span', { class: params.row.cashAmount >= 0 ? 'balance-color' : 'balance-color-green', attrs: { title: params.row.cashAmount } }, this.$money(params.row.cashAmount))
                },
                {
                    title: this.$t('信用额度支付金额'),
                    key: 'creditAmount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 160,
                    align: 'right',
                    render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.creditAmount } }, this.$money(params.row.creditAmount))
                },
                {
                    title: this.$t('充值现金券支付金额'),
                    key: 'voucherAmount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 160,
                    align: 'right',
                    render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.voucherAmount } }, this.$money(params.row.voucherAmount))
                },
                {
                    title: this.$t('抵扣现金券支付金额'),
                    key: 'voucherAmount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 160,
                    align: 'right',
                    render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.deductCouponDiscount } }, this.$money(params.row.deductCouponDiscount))
                },
                {
                    title: this.$t('抹零金额'),
                    key: 'eraseZeroAmount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    resizable: true,
                    width: 120,
                    align: 'right',
                    render: (h, params) => h('span', { class: 'balance-color', attrs: { title: params.row.eraseZeroAmount } }, this.$money(params.row.eraseZeroAmount, 5))
                },
                {
                    title: this.$t('出账金额'),
                    key: 'amount',
                    disabledSearch: true,
                    columnShow: true,
                    columnsChoosed: true,
                    className: 'ellipsis',
                    minWidth: 120,
                    align: 'right',
                    resizable: true,
                    renderHeader: (h, params) => {
                        return h('div', { style: { display: 'inline-block' } },
                            [
                                h('span', { attrs: { title: this.$i18n.t('出账金额') } }, this.$t('出账金额')),
                                h('Tooltip', {
                                    props: { transfer: true, placement: 'left', theme: 'light' }
                                }, [h('i', {
                                    class: {
                                        'icon-prompt-1-o': true,
                                        'tips-style': true
                                    },
                                    style: {
                                        'font-size': '12px',
                                        'padding-right': '30px',
                                        'margin-left': '5px'
                                    }
                                }),
                                h('div', {
                                    slot: 'content',
                                    style: {
                                        // color: '#ff6a01'
                                    }
                                }, [
                                    h('p', this.$t('包含充值现金券支付金额、抵扣现金券支付金额、现金支付金额和信用额度支付金额。'))
                                ]
                                )]
                                )
                            ])
                    },
                    render: (h, params) => h('span', {
                        class: params.row.amount >= 0 ? 'balance-color' : 'balance-color-green',
                        attrs: {
                            title: params.row.amount
                        }
                    }, this.$money(params.row.amount))
                }
            ]
        }
    },
    methods: {
        toggleTask () {
            this.$emit('toggleTask')
        },
        toggleExport (params) {
            this.$emit('toggleExport', params, 'cycle')
        }
    }
}
</script>
<style lang="less">
.billcycle-container {
    height: 100%;
    .billcycle-pack {
        height: 100%;
    }
    .ivu-tabs-content {
        height: calc(~'100% - 55px');
    }
}
</style>
